<template>
  <div>
    <div v-if="this.location.latitude !== 0">
      <transition name="fade">
        <div v-if="!map.isReady" class="col-xs-12 cover" style="display: table">
          <div class="busy">{{ this.map.statusText }}</div>
        </div>
      </transition>
      <gmap-map
        :center="center"
        :options="{ scrollwheel: false }"
        style="width: 100%; height: 300px"
        :zoom="14"
        ref="map"
      >
        <gmap-marker
          v-for="(marker, index) in this.markers"
          :key="index"
          :position="marker.position"
          :icon="marker.icon"
          :clickable="true"
          :draggable="false"
          @click="center = marker.position"
        ></gmap-marker>
        <!-- <gmap-polyline
          :path="this.path"
          :options="this.options"
        ></gmap-polyline> -->
      </gmap-map>
    </div>
    <div v-else class="no-map">No map available for address details.</div>
  </div>
</template>

<script>
// import { load, Map, Marker } from "vue2-google-maps";

export default {
  props: ['report', 'location'],
  data() {
    return {
      markers: [
        {
          position: {
            lat: parseFloat(this.location.latitude),
            lng: parseFloat(this.location.longitude),
          },
        },
      ],
      place: null,
      errors: [],
      center: {
        lat: parseFloat(this.location.latitude),
        lng: parseFloat(this.location.longitude),
      },
      path: [],
      options: {
        strokeColor: '#1f6b9b',
        strokeWeight: '5',
        strokeOpacity: '.6',
      },
      dataHasLoaded: true,
      map: {
        isReady: true,
        statusText: 'Loading',
      },
      currentUserOauthToken: localStorage.getItem('currentUserOauthToken'),
    };
  },
};
</script>

<style>
.cover {
  display: inline;
  background-color: #fff;
  z-index: 999;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.busy {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  color: #d6d6d6;
}

.no-map {
  background-color: #efefef;
  padding: 20px;
  text-align: center;
}
</style>
